<template>
	<layout-admin>
		<div>
			<div class="row" v-if="match">
				<div class="col-md-6">
					<h3>{{ __("Seller") }}</h3>
					<admin-alt-broker-show-user :user="seller" />
					<tradable-terms-summary :offer="offerSell" :extended="true" />
				</div>

				<div class="col-md-6">
					<h3>{{ __("Buyer") }}</h3>
					<admin-alt-broker-show-user :user="buyer" />
					<tradable-terms-summary :offer="offerBuy" :extended="true" />
				</div>
			</div>
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";
import TradableTermsSummary from "../../components/TradableTermsSummary.vue";
let options = require("../../cropOptions");
export default {
	components: { TradableTermsSummary },
	props: {
		initialData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			match: null,
			offerBuy: null,
			offerSell: null,
			buyer: false,
			seller: false,
		};
	},
	async created() {
		console.log("HERE");
		this.match = this.initialData.match;
		this.offerBuy = this.initialData.offer_buy;
		this.offerSell = this.initialData.offer_sell;
		this.buyer = this.initialData.buyer;
		this.seller = this.initialData.seller;
	},
};
</script>
